module.exports = __webpack_public_path__ + "static/media/wizualizacja-72.25e2567e.png";